import React from "react";
import { Facebook, Instagram, Linkedin, Youtube, ExternalLink } from "lucide-react";
import ahd_logo from "../../../assets/images/ahd_profile.png";
import "./SocialMedia.css";

const SOCIAL_CHANNELS = [
  {
    name: "Instagram",
    handle: "@allhomedesire",
    count: "4.5K+ Followers",
    description: "Property tours, modern architecture, and daily interior inspiration.",
    icon: Instagram,
    iconColor: "#E1306C",
    bgColor: "rgba(225, 48, 108, 0.08)",
    link: "https://instagram.com/allhomedesire",
    btnText: "Follow on Instagram",
  },
  {
    name: "Facebook",
    handle: "All Home Desire",
    count: "5.4K+ Community",
    description: "Latest real estate updates, verified listings, and buyer discussions.",
    icon: Facebook,
    iconColor: "#1877F2",
    bgColor: "rgba(24, 119, 242, 0.08)",
    link: "https://www.facebook.com/allhomedesire/",
    btnText: "Join on Facebook",
  },
  {
    name: "LinkedIn",
    handle: "All Home Desire",
    count: "1.2K+ Network",
    description: "Industry reports, partner network announcements, and corporate insights.",
    icon: Linkedin,
    iconColor: "#0A66C2",
    bgColor: "rgba(10, 102, 194, 0.08)",
    link: "https://www.linkedin.com/company/ushma-infotech/posts/?feedView=all",
    btnText: "Connect on LinkedIn",
  },
  {
    name: "YouTube",
    handle: "All Home Desire",
    count: "Property Walkthroughs",
    description: "Virtual property walk-throughs, expert interviews, and home tours.",
    icon: Youtube,
    iconColor: "#FF0000",
    bgColor: "rgba(255, 0, 0, 0.08)",
    link: "https://youtube.com",
    btnText: "Watch on YouTube",
  },
];

const SocialMedia = () => (
  <section className="social">
    <div className="social__container">
      <div className="social__header">
        <span className="social__label">Community & Social Proof</span>
        <h2 className="social__title">
          Connect with <em>All Home Desire</em>
        </h2>
        <p className="social__subtitle">
          Join thousands of homeowners, investors, and designers across our digital channels.
        </p>
      </div>

      <div className="social__grid">
        {SOCIAL_CHANNELS.map((item) => {
          const Icon = item.icon;
          return (
            <div key={item.name} className="social__card">
              <div className="social__card-top">
                <div
                  className="social__icon-wrap"
                  style={{ backgroundColor: item.bgColor, color: item.iconColor }}
                >
                  <Icon size={24} />
                </div>
                <span className="social__card-count">{item.count}</span>
              </div>

              <h3 className="social__card-name">{item.name}</h3>
              <p className="social__card-handle">{item.handle}</p>
              <p className="social__card-desc">{item.description}</p>

              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="social__card-btn"
              >
                <span>{item.btnText}</span>
                <ExternalLink size={14} />
              </a>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default SocialMedia;